import {ReactNode, useState} from 'react';
import classnames from 'classnames';

import {NodeData} from 'src/types';
import {ImpactScoreExplanation, PropertyList, TabList} from 'src/components';
import {NodeDetailHeader} from 'src/components';

import {NodeRelationships} from '../NodeRelationships';
import ImpactAnalysisTab from '../ImpactAnalysisTab';
import {isSearchNode} from '../../../state/dependency2';
import {SearchDetailTab} from '../SearchDetail';
import {useDirectRelationships} from '../NodeRelationships/hooks';


export const NodeDetail = ({node, goToNode}: { node: NodeData, goToNode: (id: string, name: string) => void }) => {
  const [isImpactDialogOpen, setIsImpactDialogOpen] = useState<boolean>(false);
  const {loading, directRelationships} = useDirectRelationships(node.id);

  const openImpactDialog = () => setIsImpactDialogOpen(true);
  const closeImpactDialog = () => setIsImpactDialogOpen(false);


  const tabs: Array<{tab: ReactNode, pane: ReactNode}> = [];
  tabs.push({
    tab: 'Relationships',
    pane: (!loading && directRelationships &&
      <NodeRelationships
        goToNode={goToNode}
        nodeId={node.id}
        list={directRelationships}/>
    ),
  });
  tabs.push({
    tab: 'Impact Analysis',
    pane: (
      <ImpactAnalysisTab nodeData={node}/>
    ),
  });
  if (node && node.properties) {
    tabs.push({
      tab: 'Details',
      pane: (
        <>
          {node && node.properties && <PropertyList properties={{
            id: node.id,
            identifier: node.identity,
          }}/>}
          <PropertyList properties={node.properties}/>
        </>
      ),
    });
  }
  if (isSearchNode(node.type) && node.properties.fuzzy) {
    tabs.push({
      tab: 'Search Details(beta)',
      pane: (
        <>
          <SearchDetailTab nodeId={node.id}></SearchDetailTab>
        </>
      ),
    });
  }

  /* TODO: https://crosscode.atlassian.net/browse/CAPE-1244*/
  return (
    <div className={classnames({
      'NodeDetailModalBody--hide-tab-content': isImpactDialogOpen,
    })}>
      <NodeDetailHeader
        onClickImpactScore={openImpactDialog}
        impactScore={node.properties ? node.properties['codelogic.quality.impactScore'] : null}
        id={node.id}
        identity={node.identity}
        name={node.properties?.shortName || node.name}
        type={node.type}
        showCopy={true}
      />
      <TabList
        onTabChange={closeImpactDialog}
        tabs={tabs}/>

      {isImpactDialogOpen && (<ImpactScoreExplanation score={node?.properties['codelogic.quality.impactScore']}/>)}
    </div>
  );
};
